import { createContext, useContext, useState, useCallback } from 'react';
import type { ReactNode } from 'react';

export type ToastKind = 'ok' | 'err' | 'info';

export type ToastFn = (msg: string, kind?: ToastKind) => void;

const ToastCtx = createContext<ToastFn>(() => {});

export function useToast(): ToastFn {
  return useContext(ToastCtx);
}

interface ToastEntry {
  id: string;
  msg: string;
  kind: ToastKind;
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastEntry[]>([]);

  const push = useCallback<ToastFn>((msg, kind = 'ok') => {
    const id = Math.random().toString(36).slice(2);
    setToasts((t) => [...t, { id, msg, kind }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3200);
  }, []);

  return (
    <ToastCtx.Provider value={push}>
      {children}
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.kind}`}>
            <i
              className={`fa-solid ${
                t.kind === 'ok'
                  ? 'fa-circle-check'
                  : t.kind === 'err'
                    ? 'fa-circle-exclamation'
                    : 'fa-circle-info'
              }`}
            ></i>
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
